import { render, staticRenderFns } from "./Sparepart.vue?vue&type=template&id=d40440fa"
import script from "./Sparepart.vue?vue&type=script&lang=js"
export * from "./Sparepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports